import { render } from "./System.templates.vue?vue&type=template&id=797c32b9&scoped=true"
import script from "./System.templates.vue?vue&type=script&lang=js"
export * from "./System.templates.vue?vue&type=script&lang=js"

import "./System.templates.vue?vue&type=style&index=0&id=797c32b9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797c32b9"]])

export default __exports__